import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectProfilingProgressData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.progressData.profilingProgressData

export const selectProfilingProgressLoadingStatus = createSelector(
  [selectProfilingProgressData],
  ({ status }) => status
)

export const selectLRProgressData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.progressData.lrProgressData

export const selectLRProgressLoadingStatus = createSelector(
  [selectLRProgressData],
  ({ status }) => status
)

export const selectContractSignatureProgressData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.progressData.contractSignatureProgressData

export const selectContractSignatureProgressLoadingStatus = createSelector(
  [selectContractSignatureProgressData],
  ({ status }) => status
)
